export default __webpack_public_path__ + "static/media/Flag_of_Vanuatu.4aae1b71.svg";